import { render } from "./ItineraryFormSidebar.vue?vue&type=template&id=2dde0ccf"
import script from "./ItineraryFormSidebar.vue?vue&type=script&lang=js"
export * from "./ItineraryFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__